module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "wrap-banner"
  }, [_vm._m(0), _vm._v(" "), _c('vue-particles', {
    attrs: {
      "color": "#ffffff",
      "particleOpacity": 0.7,
      "linesColor": "#ffffff",
      "particlesNumber": 80,
      "shapeType": "circle",
      "particleSize": 5,
      "linesWidth": 2,
      "lineLinked": true,
      "lineOpacity": 0.4,
      "linesDistance": 150,
      "moveSpeed": 3,
      "hoverEffect": true,
      "hoverMode": "grab",
      "clickEffect": true,
      "clickMode": "push"
    }
  })], 1), _vm._v(" "), _c('main-content'), _vm._v(" "), _c('foot')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-title"
  }, [_c('h2', [_vm._v("\n        Vue-Particles\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("\n        Vue.js component for particles backgrounds\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("\n        SSR compatible\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "gh-button",
    attrs: {
      "target": "_blank",
      "href": "https://github.com/creotip/vue-particles"
    }
  }, [_c('span', {
    staticClass: "gh-button__icon"
  }), _vm._v("Download")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 27
// module chunks = 0